import {chain, isArray, flatten} from 'lodash'
import diff from 'deep-diff'

const log = console.log.bind(console)

const hooks = []

export function register(path, trigger) {
  const paths = isArray(path) ? path : [path]
  const triggers = isArray(trigger) ? trigger : [trigger]
  paths.forEach(p => triggers.forEach(t => hooks.push(createHook(p, t))))
}

function createHook (path, callback) {
  const trigger = (...diff) => (...args) => callback.apply(path, args.concat(diff))
  const hook = {path, trigger, hook: callback}
  return  hook
}

export default function trigger(current, previous) {
  const difference = diff(current, previous, filterHooks)
  if (difference) {
    const hooks = chain(difference)
      .map(createTrigger)
      .flatten()
      .uniqBy('hook')
      .map(hook => ({...hook, trigger: hook.trigger(hook.diff)}))
      .value()
    hooks.forEach(hook => hook.trigger(current, hook.path, hook.diff))
  }
}


function filterHooks(path, key) {
  const id = path.concat([key]).join('/')
  return !hooks.some(matchHookId(id))
}

function createTrigger(diff) {
  return chain(hooks)
    .filter(matchHookId(diff.path.join('/')))
    .uniqBy('hook')
    .map(trigger => ({...trigger, diff}))
    .value()
}

function matchHookId(id) {
  return ({path}) => {
    if (path.length > id.length) return path.startsWith(id)
    else return id.startsWith(path)
  }
}
